<script>
    import {goto} from "@sveltech/routify";
    import {_} from 'svelte-i18n';
    import {getContext} from "svelte";
    const MyAnalytics = getContext('MyAnalytics');
    import { Button } from 'sveltestrap';

    const handleClick = () => {
        MyAnalytics.logEvent('event_new_click');
        $goto('/app/events/new');
    }
</script>

<Button color="secondary" size="sm" on:click={handleClick}>{$_('component.newEventButton.label')}</Button>